/**
 * Default clock times of a "N× per day" pump plan without explicit times —
 * the same rule the backend uses to auto-log the doses
 * (src/services/dosingPumpSchedule.ts → defaultDoseTimes):
 * 1× → 09:00, 2× → 09:00 / 21:00, N× → evenly spaced over 24 h from 08:00.
 */
export function defaultDoseTimes(count: number): string[] {
  const n = Math.min(Math.max(Math.trunc(count) || 1, 1), 24);
  if (n === 1) return ['09:00'];
  if (n === 2) return ['09:00', '21:00'];
  const step = Math.floor(1440 / n);
  return Array.from({ length: n }, (_, i) => (8 * 60 + i * step) % 1440)
    .sort((a, b) => a - b)
    .map((m) => `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`);
}

/** Default clock time of a pump plan with one dose per dosing day. */
export const DEFAULT_SINGLE_DOSE_TIME = '09:00';

/**
 * The time inputs to show for `count` doses: the stored/edited times when
 * there is one per dose, otherwise the defaults.
 */
export function doseTimesFor(count: number, current: readonly string[]): string[] {
  return current.length === count ? [...current] : defaultDoseTimes(count);
}
